import { useEffect, useState } from "react";
import axios from "axios";
import { GraduationCap, Handshake, Star, Heart, Question } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CATEGORY_ICONS = {
  "Formazione": GraduationCap,
  "Coaching": Handshake,
  "Mentoring": Star,
  "Supporto Personale": Heart,
};

const PRIORITY_COLOR = {
  "Alta": "text-red-600 bg-red-50 border-red-200",
  "Media": "text-amber-600 bg-amber-50 border-amber-200",
  "Bassa": "text-emerald-600 bg-emerald-50 border-emerald-200",
};

export default function EmployeeDevPlanSection({ employeeId }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!employeeId) return;
    axios.get(`${API}/employees/${employeeId}`, { withCredentials: true })
      .then(r => {
        const plan = (r.data?.action_plan || []).filter(t => t.approved && (t.status || "Da fare") !== "Rimosso");
        setTasks(plan);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [employeeId]);

  if (loading) return <p className="text-xs text-[#0D1F3C]/50">Caricamento piano...</p>;

  if (tasks.length === 0) {
    return (
      <div className="text-sm text-[#0D1F3C]/60 bg-[#F4F7FB] border border-[#0D1F3C]/8 rounded-lg p-4" data-testid="dev-plan-empty">
        <p><strong>Nessun task approvato nel piano di sviluppo.</strong></p>
        <p className="mt-1 text-xs">Vai alla scheda dipendente per approvare i task generati automaticamente.</p>
      </div>
    );
  }

  const grouped = tasks.reduce((acc, t) => {
    const cat = t.category || "Altro";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(t);
    return acc;
  }, {});

  return (
    <div className="space-y-4" data-testid="dev-plan-section">
      {Object.entries(grouped).map(([cat, list]) => {
        const Icon = CATEGORY_ICONS[cat] || Question;
        return (
          <div key={cat}>
            <div className="flex items-center gap-2 mb-2">
              <Icon size={18} weight="duotone" className="text-[#1B4FD8]" />
              <h4 className="text-sm font-semibold text-[#0D1F3C] uppercase tracking-wide">{cat} <span className="text-[#0D1F3C]/40 font-normal">({list.length})</span></h4>
            </div>
            <ul className="space-y-1.5 pl-6">
              {list.map((t, i) => (
                <li key={t.id || i} className="text-sm text-[#0D1F3C]/80 flex items-start gap-2">
                  <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] border ${PRIORITY_COLOR[t.priority] || PRIORITY_COLOR.Media}`}>
                    {t.priority || "Media"}
                  </span>
                  {t.due_date && <span className="text-[11px] text-[#0D1F3C]/50 whitespace-nowrap">{new Date(t.due_date).toLocaleDateString('it-IT')}</span>}
                  <span className="flex-1">{t.description}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
